/**
 * Feature Flags pro postupnou migraci na nové Mapy.com API
 *
 * Postup migrace:
 * 1. USE_NEW_SUGGEST_API = true (nejmenší riziko)
 * 2. USE_NEW_MAP_API = true (střední riziko)
 * 3. USE_NEW_PANORAMA_API = true (největší riziko)
 *
 * Každý flag lze nezávisle přepnout zpět na false pro rychlý rollback.
 */

export const FEATURE_FLAGS = {
    /**
     * Fáze 1: Použít nové REST API pro suggest/autocomplete
     * Nahrazuje: SMap.Suggest
     * Nové: fetch na https://api.mapy.com/v1/suggest
     */
    USE_NEW_SUGGEST_API: true,

    /**
     * Fáze 2: Použít Leaflet + REST API tiles místo SMap
     * Nahrazuje: new SMap(), Layer.Marker, Layer.Geometry, signals
     * Nové: react-leaflet komponenty + Mapy.com tile server
     */
    USE_NEW_MAP_API: true,

    /**
     * Fáze 3: Použít nové JS Panorama API
     * Nahrazuje: SMap.Pano.Scene, SMap.Pano.getBest
     * Nové: Panorama.panoramaFromPosition, Panorama.panoramaExists
     */
    USE_NEW_PANORAMA_API: true,
};

/**
 * Helper pro kontrolu, zda lze používat staré API
 * Vrací true pokud alespoň jeden flag je false (tedy potřebujeme staré API)
 */
export const needsLegacyApi = (): boolean => {
    return !FEATURE_FLAGS.USE_NEW_SUGGEST_API || !FEATURE_FLAGS.USE_NEW_MAP_API || !FEATURE_FLAGS.USE_NEW_PANORAMA_API;
};

/**
 * Helper pro kontrolu, zda je migrace dokončena
 */
export const isMigrationComplete = (): boolean => {
    return FEATURE_FLAGS.USE_NEW_SUGGEST_API && FEATURE_FLAGS.USE_NEW_MAP_API && FEATURE_FLAGS.USE_NEW_PANORAMA_API;
};
